export async function fetchAndConvertCsvToJson(csvUrl) {
  try {
    const response = await fetch(
      `/api/csv-to-json?csvUrl=${encodeURIComponent(csvUrl)}`
    );

    if (!response.ok) throw new Error("Failed to convert CSV");

    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
    console.error("Error converting CSV to JSON:", error);
    return [];
  }
}

// ✅ Download CSV with custom filename (via backend proxy)
export const DownloadCsvFile = async (csvUrl, fileName = "data.csv") => {
  try {
    const response = await fetch(
      `/api/download-csv?csvUrl=${encodeURIComponent(csvUrl)}&fileName=${encodeURIComponent(fileName)}`
    );

    if (!response.ok) throw new Error("Failed to download CSV");

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName.endsWith(".csv") ? fileName : `${fileName}.csv`;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);

    console.log(`CSV downloaded: ${fileName}`);
  } catch (error) {
    console.error("Download failed:", error);
    // Fallback: open directly
    window.open(csvUrl, "_blank");
  }
};